import React from "react";
import Footer from "./Footer";
import PropTypes from "prop-types";

export const Layout = ({ children }) => {
  return (
    <div className="app-container">
      {/* Add header component if needed */}
      <main>{children}</main>
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
